// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wWVgE{display:flex;flex-direction:column;gap:32px;width:100%;margin-bottom:16px}.oWDfD{display:flex;flex-direction:row;gap:5px;align-items:center}.oWDfD .mGMnh{display:flex;flex-direction:row;gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fileDetailsWrapper": `wWVgE`,
	"fileDetails": `oWDfD`,
	"fileDetailsText": `mGMnh`
};
export default ___CSS_LOADER_EXPORT___;
